var map = {
	"./Panjab_University_logo.png": 893,
	"./coursera.svg": 1885,
	"./data_science.png": 9248,
	"./deeplearning_ai_logo.png": 8669,
	"./infowiz_logo.png": 5842,
	"./machine_learning.png": 5148,
	"./spring.svg": 808,
	"./tcil_it.png": 2634,
	"./udemy.svg": 6704,
	"./web_development.svg": 5726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;